export default class MapLoadingError extends Error {
  constructor(e) {
    super(e)
    this.originalError = e
    this.name = 'MapLoadingError'
  }
}
